import { useState, useEffect } from 'react'
import { ACTIVITY_STATUS_TICK_INTERVAL_MS } from '../constants/activitySync'

/**
 * Returns a counter that increments every `intervalMs` milliseconds.
 * Use as a dependency in useMemo to force re-evaluation of time-based
 * computations (e.g. isActivityLive, hasAnySoon) without any network calls.
 *
 * @param intervalMs - How often to tick. Defaults to ACTIVITY_STATUS_TICK_INTERVAL_MS (30s).
 */
export const useActivityStatusTick = (intervalMs: number = ACTIVITY_STATUS_TICK_INTERVAL_MS): number => {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])

  return tick
}
